import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { noop } from 'Helpers/PropTypes';
import { Button } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import Text from 'Components/ComponentLibrary/Atoms/Text';

const useStyles = buildUseStyles('ToggleAttributeButton', (theme) => ({
  root: {
    padding: theme.spacing(1),
    margin: theme.spacing(0.5),

    '& .MuiIconButton-label': {
      flexWrap: 'wrap',
    },
  },
  attributeLabel: {
    padding: theme.spacing(1),
    whiteSpace: 'nowrap',
    fontSize: '0.875rem',
  },
}));

const ToggleAttributeButton = ({
  className,
  label,
  icon,
  secondaryIcon,
  value,
  color,
  size,
  onChange,
  dataTestKeys,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let ButtonIcon = icon;
  if (secondaryIcon) {
    ButtonIcon = value ? icon : secondaryIcon;
  }

  const handleToggle = async (event) => {
    await onChange(event, (!value).toString());
  };

  return (
    <Button
      className={classNames(className, classes.root)}
      onClick={(event) => handleToggle(event)}
      color={color}
      variant={'icon'}
      padding={'none'}
      {...dataTestKeys}
    >
      {icon && <ButtonIcon fontSize={size} />}
      {label && <Text className={classes.attributeLabel} variant={'h5'} color={'textPrimary'} text={label} /> }
    </Button>
  );
};

ToggleAttributeButton.defaultProps = {
  className: '',
  label: '',
  icon: null,
  secondaryIcon: null,
  onChange: noop,
  color: 'primary',
  size: 'default',
  dataTestKeys: {},
  fullWidth: false,
};

ToggleAttributeButton.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.object,
  secondaryIcon: PropTypes.object,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  color: PropTypes.string,
  size: PropTypes.string,
  dataTestKeys: PropTypes.object,
  fullWidth: PropTypes.bool,
};

export default ToggleAttributeButton;
